import { useGetAddOnsQuery, useGetHomeQuery, useGetPlansQuery } from "@/store/rest_api";
import { AddOnType } from "@/model/interface/AddOn";

const PROPERTY_DATA_ADD_ONS: AddOnType[] = [AddOnType.PROPERTY_DATA_5K, AddOnType.PROPERTY_DATA_10K];

export function usePropertyDataAtCost(): boolean {
  const { data: home } = useGetHomeQuery();
  const { data: plans } = useGetPlansQuery();
  const activeSlug = home?.activeOrganisation?.activePlan?.toLowerCase();
  return plans?.find((plan) => plan.slug === activeSlug)?.pricingMode === "AT_COST";
}

export function useAddOn(addOns: AddOnType | AddOnType[]): boolean {
  const types = Array.isArray(addOns) ? addOns : [addOns];
  const { data } = useGetAddOnsQuery();
  const isPropertyDataAtCost = usePropertyDataAtCost();
  if (isPropertyDataAtCost && types.every((type) => PROPERTY_DATA_ADD_ONS.includes(type))) {
    return true;
  }
  return data?.some((addOn) => types.includes(addOn.addOnType) && addOn.quantity > 0) === true;
}
